import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Clickable, Icon, Layout, Text } from 'ds';
import { AI_ASSISTANT_PATH } from 'routes';
import { actions } from 'store/AIAssistant';
import { useAppDispatch } from 'store/hooks';

import { WidgetVariant } from './types';
import { determineIntent, startThread } from '../AIAssistant/requests';
import { SUGGESTED_CHATBOT_PROMPTS } from '../constants';

interface Props {
  variant: WidgetVariant;
}

const AskCodiWidget: React.FC<Props> = ({ variant = 'full' }) => {
  const [prompt, setPrompt] = useState<string>();

  useEffect(() => {
    setPrompt(SUGGESTED_CHATBOT_PROMPTS[Math.floor(Math.random() * SUGGESTED_CHATBOT_PROMPTS.length)]);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const dispatch = useAppDispatch();
  const history = useHistory();

  const handlePromptCardClick = async (input: string) => {
    if (!prompt) return;
    setTimeout(async () => {
      const { data } = await startThread();
      dispatch(actions.addThread(data));
      dispatch(actions.addPendingThreadInteraction({ threadId: data.id, input }));
      history.push(`${AI_ASSISTANT_PATH}/${data.id}`);
      const { data: interaction } = await determineIntent({
        chatbotThreadId: data.id,
        message: prompt,
        intentGroup: 'tenancy_customers'
      });
      dispatch(actions.removePendingThreadInteraction({ threadId: data.id }));
      dispatch(actions.addInteraction({ interaction, threadId: data.id }));
    }, 700);
  };

  if (!prompt) return null;

  if (variant === 'half') {
    return (
      <Clickable onClick={() => handlePromptCardClick(prompt)} fullWidth fullHeight>
        <Layout
          color="purple-gradient-transparent"
          borderRadius={16}
          padding={16}
          height="100%"
          direction="column"
          justify="center"
          gap={4}
        >
          <Layout align="center">
            <Icon name="sparkle" color="purple-gradient" size={32} />
            <Text size="body-sm" color="purple-gradient" semibold align="left">
              {prompt}
            </Text>
          </Layout>
        </Layout>
      </Clickable>
    );
  }

  return (
    <Clickable onClick={() => handlePromptCardClick(prompt)} fullWidth fullHeight>
      <Layout
        color="purple-gradient-transparent"
        borderRadius={16}
        padding={16}
        height="100%"
        direction="column"
        justify="center"
        gap={4}
      >
        <Icon name="sparkle" color="purple-gradient" size={32} />
        <Text size="overline-sm" color="purple-gradient" align="left">
          ASK CODI
        </Text>
        <Text size="headline-xs" color="purple-gradient" align="left">
          {prompt}
        </Text>
      </Layout>
    </Clickable>
  );
};

export default AskCodiWidget;
